
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"25.167","cy":"8.833","fill":"#F03838","r":"3.5"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.875 13.5a5.125 5.125 0 016.59-4.913 1 1 0 10.57-1.917 7.125 7.125 0 00-9.16 6.83v2.502a3.625 3.625 0 00-3.5 3.623v2.625c0 1.035.84 1.875 1.875 1.875h4.252a4.5 4.5 0 008.996 0h4.252c1.035 0 1.875-.84 1.875-1.875v-2.625a3.625 3.625 0 00-3.5-3.623v-1.335a1 1 0 10-2 0V18H24c.898 0 1.625.727 1.625 1.625v2.5H8.375v-2.5C8.375 18.727 9.103 18 10 18h1.875v-4.5zm7.622 10.625h-4.994a2.5 2.5 0 004.994 0z","fill":"currentColor"}})])
          )
        }
      }
    